'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClientTriggers = undefined;

var _scrollTriggerEnabled = require('../../scroll-percentage-trigger/operators/scrollTriggerEnabled');

var _timeOnPageTriggerEnabled = require('../../time-on-page-trigger/operators/timeOnPageTriggerEnabled');

var _exitIntentTriggerEnabled = require('../../exit-intent-trigger/operators/exitIntentTriggerEnabled');

var hasClientTriggers = exports.hasClientTriggers = function hasClientTriggers(widgetData) {
  return (0, _scrollTriggerEnabled.scrollTriggerEnabled)(widgetData) || (0, _timeOnPageTriggerEnabled.timeOnPageTriggerEnabled)(widgetData) || (0, _exitIntentTriggerEnabled.exitIntentTriggerEnabled)(widgetData);
};